import { ElementAttribute } from "../../../dom-tools/ElementAttribute";
import { ElementType } from "../../../dom-tools/ElementType";
import { Range } from "../../../geometry/Range";
import { MathX } from "../../../math/MathX";
import { TextFX } from "../TextFX";
import { TextFXElement } from "../TextFXElement";
import { TextFXLetter } from "../TextFXLetter";
import { TextFXModule, TextFXModuleSettings } from "../TextFXModule";

export class TransformTextFXSettings extends TextFXModuleSettings
{
  value:string[];
  byPosition:number;
  duration:Range;
  delay:Range;
}

export class TransformTextFX extends TextFXModule
{
  static readonly elementType    = new ElementType( "text--fx-transform-fading");

  static readonly value      = new ElementAttribute( "value" );
  static readonly byPosition = new ElementAttribute( "by-position" );
  static readonly duration   = new ElementAttribute( "duration" );
  static readonly delay      = new ElementAttribute( "delay" );

  get type() { return TransformTextFX.elementType; }

  getSettings( element:Element )
  {
    let settings = new TransformTextFXSettings();
    settings.module = this;
    
    settings.value       = TransformTextFX.value.parseStrings( element );
    settings.byPosition  = TransformTextFX.byPosition.asNumberFrom( element );
    settings.duration    = TransformTextFX.duration.asRange( element );
    settings.delay       = TransformTextFX.delay.asRange( element );

    return settings;
  }

 
  apply( letter:TextFXLetter[], settings:TextFXModuleSettings )
  {
    let fadingSettings = settings as TransformTextFXSettings;
    letter.forEach( l => this.#applyOnLetter( l,  fadingSettings ) );
  }

  
  #applyOnLetter( textLetter:TextFXLetter, settings:TransformTextFXSettings )
  {    
    let element  = textLetter.element as HTMLElement;
    let position = textLetter.letterPosition;  

    let fadeByPositionValue = settings.byPosition >= 0 ?  
                                MathX.lerp( 1, position, settings.byPosition ) :
                                MathX.lerp( position, 1, -settings.byPosition );
    
    let value         = TextFX.random.from( settings.value );
    let fadeDuration  = TextFX.random.in( settings.duration ) * fadeByPositionValue;
    let delayDuration = TextFX.random.in( settings.delay ) * fadeByPositionValue;
    
    textLetter.setTransition( "transform", fadeDuration, delayDuration );

    element.style.transform = value + "";
  }


}